import React, { FC } from "react";
// @ts-ignore
import { DatePicker } from 'antd';
import type { RangePickerProps } from 'antd/es/date-picker';
import "react-clock/dist/Clock.css";
import "react-calendar/dist/Calendar.css";
import "react-datetime-picker/dist/DateTimePicker.css";
import { IInputProps } from "../../../modules/form";
import moment from "moment";
import { DateFormat } from "../../../constants";

interface IInputDateTimeProps extends IInputProps {
  minDate?: any;
  isShowTime?: boolean;
}

export const InputDateTimeAntd: FC<IInputDateTimeProps> = (props) => {
  const { value, onChange, isDisabled, minDate } = props;

  const disabledDate: RangePickerProps['disabledDate'] = current => {
    // Can not select days before today and today
    return current && minDate && current < moment(minDate);
  };

  return (
    <DatePicker 
      showTime 
      onChange={onChange} 
      value={moment(value, DateFormat.DD_MM_YYYY_HH_MM)}
      allowClear={false}
      disabledDate={disabledDate}
      clearIcon={false}
      format={DateFormat.DD_MM_YYYY_HH_MM}
      disabled={isDisabled}
      className="InputDateTime"
    />
    // <DateTimePicker
    //   className="InputDateTime"
    //   calendarClassName="InputDateTimeCalendar"
    //   // clockClassName="InputDateTimeClock"
    //   onChange={onChange}
    //   minDate={minDate || null}
    //   value={value}
    //   locale="vi-VN"
    //   disabled={isDisabled}
    //   format={isShowTime ? "dd/MM/yyyy H:mm" : "dd/MM/yyyy"}
    // />
  );
  // return <input type='datetime-local' />
};
